import React, { useState, useEffect, useRef } from 'react';
import { AmenitiesSection } from '../NewComponents/sections/AmenitiesSection';
import { FeaturesSection } from '../NewComponents/sections/FeaturesSection';
import { FAQSection } from '../NewComponents/sections/FAQSection';
import BookATour from '../NewComponents/sections/BookATour';
import { Header } from '../NewComponents/layout/Header';
import TestimonialsSection from '../NewComponents/sections/TestimonialsSection';
import { FloatingBookButton } from '../NewComponents/ui/FloatingBookButton';
import MapSection from '../NewComponents/sections/MapSection';
import { Footer } from '../NewComponents/layout/Footer';
import { HeroMeeting } from '../NewComponents/sections/HeroMeeting';

const LandingPageMeeting = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [hasShownMapPopup, setHasShownMapPopup] = useState(false);
  const mapRef = useRef(null);

  // Show popup after 10 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsPopupOpen(true);
    }, 10000);

    return () => clearTimeout(timer);
  }, []);

  // Show popup again when user scrolls to the Map section
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasShownMapPopup) {
          setIsPopupOpen(true);
          setHasShownMapPopup(true);
        }
      },
      {
        root: null,
        threshold: 0.5, // 50% visible
      }
    );

    const mapEl = mapRef.current;
    if (mapEl) observer.observe(mapEl);

    return () => {
      if (mapEl) observer.unobserve(mapEl);
    };
  }, [hasShownMapPopup]);

  return (
    <div className="bg-white flex flex-col overflow-hidden items-center">
      <Header />
      <FloatingBookButton />
      {/* <FreeDayPopup isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} /> */}
      <main>
        <div>
          <HeroMeeting />
        </div>
        {/* <div id="book-a-tour">
          <BookATour />
        </div> */}
        <div id="amenities">
          <AmenitiesSection />
        </div>
        <div>
          <TestimonialsSection />
        </div>
        <div>
          <FAQSection />
        </div>
        <div ref={mapRef}>
          <MapSection />
        </div>
        <div className="w-[100vw]">
          <Footer />
        </div>
      </main>
    </div>
  );
};

export default LandingPageMeeting;
